module.exports = __webpack_public_path__ + "static/media/polygon-zkevm.6edb2012.svg";